import { HTTP_STATUS_UNPROCESSABLE_ENTITY } from '@/lib/redirect'

// An offline axios request resolves with no `response` object at all —
// unlike a 4xx/5xx, which always has one. But other things (CORS, a timeout)
// can also produce a response-less error, so that alone isn't proof the
// device is offline — pair it with navigator.onLine, which is what actually
// tells us that.
export function isOfflineError(error: unknown): boolean {
  return !navigator.onLine && (error as { response?: unknown })?.response === undefined
}

// Shared error-message extraction for failed API calls. The Laravel API
// returns { message: string } in the response body on 4xx/5xx errors.
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (isOfflineError(error)) {
    return "You're offline. Check your connection and try again."
  }

  return (
    (error as { response?: { data?: { message?: string } } })?.response?.data?.message ?? fallback
  )
}

// Laravel returns 422s as { message, errors: { field: [msg, ...] } }. Views
// render these next to the field that failed, so an error from any other
// status (or a network failure) has to come back as an empty map rather than
// something the caller has to null-check.
export function apiValidationErrors(error: unknown): Record<string, string[]> {
  const response = (error as { response?: { status?: number; data?: { errors?: unknown } } })?.response

  if (response?.status !== HTTP_STATUS_UNPROCESSABLE_ENTITY || typeof response.data?.errors !== 'object' || response.data.errors === null) {
    return {}
  }

  return response.data.errors as Record<string, string[]>
}
